import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/onboard/404'
import Error from '@/components/onboard/error'
import BlueOffer from '@/components/onboard/blue_offer'
import BlueOfferJoint from '@/components/onboard/blue_offer_joint'
import BlueOfferElementary from '@/components/onboard/blue_offer_elementary'
import BlueOfferElementaryJoint from '@/components/onboard/blue_offer_elementary_joint'
import Certify from '@/components/onboard/certify'
import Code from '@/components/onboard/code'
import Edu from '@/components/onboard/edu'
import Family from '@/components/onboard/family'
import Index from '@/components/onboard/index'
import Info from '@/components/onboard/info'
import InternBlueOffer from '@/components/onboard/intern_blue_offer'
import InternOffer from '@/components/onboard/intern_offer'
import InternStoreOffer from '@/components/onboard/intern_store_offer'
import List from '@/components/onboard/list'
import Material from '@/components/onboard/material'
import Plan from '@/components/onboard/plan'
import Preview from '@/components/onboard/preview'
import SocialInternStoreOffer from '@/components/onboard/social_intern_store_offer'
import SpecialOffer from '@/components/onboard/special_offer'
import StoreOffer from '@/components/onboard/store_offer'
import SubmitBack from '@/components/onboard/submit_back'
import Success from '@/components/onboard/success'
import Supplement from '@/components/onboard/supplement'
import Certificate from '@/components/onboard/certificate'
import Thanks from '@/components/onboard/thanks'
import Train from '@/components/onboard/train'
import Upload from '@/components/onboard/upload'
import WhiteOffer from '@/components/onboard/white_offer'
import WhiteOfferRsu from '@/components/onboard/white_offer_rsu'
import WhiteOfferJoint from '@/components/onboard/white_offer_joint'
import SchoolOffer from '@/components/onboard/school_offer'
import SchoolOfferSsp from '@/components/onboard/school_offer_ssp'
import SchoolStoreOffer from '@/components/onboard/school_store_offer'
import SchoolOfferBj from '@/components/onboard/school_offer_bj'
import SchoolOfferSh from '@/components/onboard/school_offer_sh'
import SchoolOfferSale from '@/components/onboard/school_offer_sale'
import SchoolOfferProd from '@/components/onboard/school_offer_prod'
import Work from '@/components/onboard/work'
import SchoolRefuse from '@/components/onboard/school_refuse'
import SocietyRefuse from '@/components/onboard/society_refuse'
import SchoolRefuseResult from '@/components/onboard/school_refuse_result'
import SchoolGraduate from '@/components/onboard/school_graduate'
import CampusRecruitmentRefuse from '@/components/onboard/campus_recruitment_refuse'
import CampusRecruitmentRefuseSuccess from '@/components/onboard/campus_recruitment_refuse_success'
import SchoolOfferBjChj from '@/components/onboard/school_offer_bj_chj'
import SchoolOfferShLxqc from '@/components/onboard/school_offer_sh_lxqc'
import SchoolOfferProdSale from '@/components/onboard/school_offer_prod_sale'
import WhiteSchoolOfferStock from '@/components/onboard/white_school_offer_stock'
import WhiteSchoolOffer from '@/components/onboard/white_school_offer'
import StoreSchoolOfferSale from '@/components/onboard/store_school_offer_sale'
import StoreSchoolOfferCdwl from '@/components/onboard/white_school_offer_cdwl'
import SchoolSalesSchool from '@/components/onboard/school_sales_school'
import StoreSchoolOfferProduct from '@/components/onboard/store_school_offer_product'
import WhiteSchoolOfferStockRr from '@/components/onboard/white_school_offer_stock_rr'
import WhiteSchoolOfferRr from '@/components/onboard/white_school_offer_rr'
import StoreSchoolOfferSaleRr from '@/components/onboard/store_school_offer_sale_rr'
import StoreSchoolOfferProductRr from '@/components/onboard/store_school_offer_product_rr'
import WhiteSchoolOfferXc from '@/components/onboard/white_school_offer_xc'
import WhiteSchoolOfferEn from '@/components/onboard/white_school_offer_en'
import WhiteSchoolOfferIntEn from '@/components/onboard/white_school_offer_int_en'
import NewWhiteOffer from '@/components/onboard/new_white_offer'
import NewWhiteOfferEn from '@/components/onboard/new_white_offer_en'
import newStoreOffer from '@/components/onboard/new_store_offer'
import newBlueOffer from '@/components/onboard/new_blue_offer'
import newInternOffer from '@/components/onboard/new_intern_offer'
import newBlueResearchOffer from '@/components/onboard/new_blue_research_offer'
import newWhiteSchoolOfferStock from '@/components/onboard/new_white_school_offer_stock'
import newWhiteSchoolOffer from '@/components/onboard/new_white_school_offer'
import newWhiteSchoolOfferEn from '@/components/onboard/new_white_school_offer_en'
import newStoreSchoolOffer from '@/components/onboard/new_store_school_offer'
import newWhiteSchoolChargingNetworkOffer from '@/components/onboard/new_white_school_charging_network_offer'
import newWhiteSchoolIntEnOffer from '@/components/onboard/new_white_school_int_en_offer'
import newBlueInternOffer from '@/components/onboard/new_blue_intern_offer'
import newCommonOffer from '@/components/onboard/new_common_offer'
import PrivacyInfo from '@/components/onboard/privacy_info'
import PrivacyTips from '@/components/onboard/privacy_tips'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/404',
      name: 'onboard.404',
      component: NotFound
    },
    {
      path: '/error',
      name: 'onboard.error',
      component: Error
    },
    {
      path: '/intent',
      name: 'intent',
      component: () => import('@/components/onboard/school_intent.vue')
    },
    {
      path: '/preview_intent',
      name: 'preview_intent',
      component: () => import('@/components/onboard/preview_intent.vue')
    },
    {
      path: '/intent_refuse',
      name: 'intent_refuse',
      component: () => import('@/components/onboard/intent_refuse.vue')
    },
    {
      path: '/blue_offer',
      name: 'onboard.blue_offer',
      component: BlueOffer
    },
    {
      path: '/blue_offer_joint',
      name: 'onboard.blue_offer_joint',
      component: BlueOfferJoint
    },
    {
      path: '/blue_offer_elementary',
      name: 'onboard.blue_offer_elementary',
      component: BlueOfferElementary
    },
    {
      path: '/blue_offer_elementary_joint',
      name: 'onboard.blue_offer_elementary_joint',
      component: BlueOfferElementaryJoint
    },
    {
      path: '/certify',
      name: 'onboard.certify',
      component: Certify
    },
    {
      path: '/code',
      name: 'onboard.code',
      component: Code
    },
    {
      path: '/edu',
      name: 'onboard.edu',
      component: Edu
    },
    {
      path: '/family',
      name: 'onboard.family',
      component: Family
    },
    {
      path: '/',
      name: 'home',
      component: Index
    },
    {
      path: '/info',
      name: 'onboard.info',
      component: Info
    },
    {
      path: '/intern_blue_offer',
      name: 'onboard.intern_blue_offer',
      component: InternBlueOffer
    },
    {
      path: '/intern_offer',
      name: 'onboard.intern_offer',
      component: InternOffer
    },
    {
      path: '/intern_store_offer',
      name: 'onboard.intern_store_offer',
      component: InternStoreOffer
    },
    {
      path: '/list',
      name: 'onboard.list',
      component: List
    },
    {
      path: '/material',
      name: 'onboard.material',
      component: Material
    },
    {
      path: '/plan',
      name: 'onboard.plan',
      component: Plan
    },
    {
      path: '/preview',
      name: 'onboard.preview',
      component: Preview
    },
    {
      path: '/social_intern_store_offer',
      name: 'onboard.social_intern_store_offer',
      component: SocialInternStoreOffer
    },
    {
      path: '/special_offer',
      name: 'onboard.special_offer',
      component: SpecialOffer
    },
    {
      path: '/store_offer',
      name: 'onboard.store_offer',
      component: StoreOffer
    },
    {
      path: '/submit_back',
      name: 'onboard.bak',
      component: SubmitBack
    },
    {
      path: '/success',
      name: 'onboard.success',
      component: Success
    },
    {
      path: '/certificate',
      name: 'onboard.certificate',
      component: Certificate
    },
    {
      path: '/supplement',
      name: 'onboard.supplement',
      component: Supplement
    },
    {
      path: '/thanks',
      name: 'onboard.thanks',
      component: Thanks
    },
    {
      path: '/train',
      name: 'onboard.train',
      component: Train
    },
    {
      path: '/upload',
      name: 'onboard.upload',
      component: Upload
    },
    {
      path: '/white_offer',
      name: 'onboard.white_offer',
      component: WhiteOffer
    },
    {
      path: '/white_offer_rsu',
      name: 'onboard.white_offer_rsu',
      component: WhiteOfferRsu
    },
    {
      path: '/white_offer_joint',
      name: 'onboard.white_offer_joint',
      component: WhiteOfferJoint
    },
    {
      path: '/school_offer',
      name: 'onboard.school_offer',
      component: SchoolOffer
    },
    {
      path: '/school_offer_ssp',
      name: 'onboard.school_offer_ssp',
      component: SchoolOfferSsp
    },
    {
      path: '/school_offer_bj',
      name: 'onboard.school_offer_bj',
      component: SchoolOfferBj
    },
    {
      path: '/school_offer_sh',
      name: 'onboard.school_offer_sh',
      component: SchoolOfferSh
    },
    {
      path: '/school_offer_sale',
      name: 'onboard.school_offer_sale',
      component: SchoolOfferSale
    },
    {
      path: '/school_offer_prod',
      name: 'onboard.school_offer_prod',
      component: SchoolOfferProd
    },
    {
      path: '/school_offer_bj_chj',
      name: 'onboard.school_offer_bj_chj',
      component: SchoolOfferBjChj
    },
    {
      path: '/school_offer_sh_lxqc',
      name: 'onboard.school_offer_sh_lxqc',
      component: SchoolOfferShLxqc
    },
    {
      path: '/school_offer_prod_sale',
      name: 'onboard.school_offer_prod_sale',
      component: SchoolOfferProdSale
    },
    {
      path: '/school_store_offer',
      name: 'onboard.school_store_offer',
      component: SchoolStoreOffer
    },
    {
      path: '/work',
      name: 'onboard.work',
      component: Work
    },
    {
      path: '/school_refuse',
      name: 'onboard.school_refuse',
      component: SchoolRefuse
    },
    {
      path: '/school_refuse_result',
      name: 'onboard.school_refuse_result',
      component: SchoolRefuseResult
    },
    {
      path: '/school_graduate',
      name: 'onboard.school_graduate',
      component: SchoolGraduate
    },
    {
      path: '/campus_recruitment_refuse',
      name: 'onboard.campus_recruitment_refuse',
      component: CampusRecruitmentRefuse
    },
    {
      path: '/campus_recruitment_refuse_success',
      name: 'onboard.campus_recruitment_refuse_success',
      component: CampusRecruitmentRefuseSuccess
    },
    {
      path: '/society_refuse',
      name: 'onboard.society_refuse',
      component: SocietyRefuse
    },
    {
      path: '/white_school_offer_stock',
      name: 'onboard.white_school_offer_stock',
      component: WhiteSchoolOfferStock
    },
    {
      path: '/white_school_offer',
      name: 'onboard.white_school_offer',
      component: WhiteSchoolOffer
    },
    {
      path: '/store_school_offer_sale',
      name: 'onboard.store_school_offer_sale',
      component: StoreSchoolOfferSale
    },
    {
      path: '/school_sales_school',
      name: 'onboard.school_sales_school',
      component: SchoolSalesSchool
    },
    {
      path: '/white_school_offer_cdwl',
      name: 'onboard.white_school_offer_cdwl',
      component: StoreSchoolOfferCdwl
    },
    {
      path: '/store_school_offer_product',
      name: 'onboard.store_school_offer_product',
      component: StoreSchoolOfferProduct
    },
    {
      path: '/white_school_offer_stock_rr',
      name: 'onboard.white_school_offer_stock_rr',
      component: WhiteSchoolOfferStockRr
    },
    {
      path: '/white_school_offer_rr',
      name: 'onboard.white_school_offer_rr',
      component: WhiteSchoolOfferRr
    },
    {
      path: '/store_school_offer_sale_rr',
      name: 'onboard.store_school_offer_sale_rr',
      component: StoreSchoolOfferSaleRr
    },
    {
      path: '/store_school_offer_product_rr',
      name: 'onboard.store_school_offer_product_rr',
      component: StoreSchoolOfferProductRr
    },
    {
      path: '/white_school_offer_xc',
      name: 'onboard.white_school_offer_xc',
      component: WhiteSchoolOfferXc
    },
    {
      path: '/white_school_offer_en',
      name: 'onboard.white_school_offer_en',
      component: WhiteSchoolOfferEn
    },
    {
      path: '/white_school_offer_int_en',
      name: 'onboard.white_school_offer_int_en',
      component: WhiteSchoolOfferIntEn
    },
    {
      path: '/new_white_offer',
      name: 'onboard.new_white_offer',
      component: NewWhiteOffer
    },
    {
      path: '/new_white_offer_en',
      name: 'onboard.new_white_offer_en',
      component: NewWhiteOfferEn
    },
    {
      path: '/new_store_offer',
      name: 'onboard.new_store_offer',
      component: newStoreOffer
    },
    {
      path: '/new_blue_offer',
      name: 'onboard.new_blue_offer',
      component: newBlueOffer
    },
    {
      path: '/new_intern_offer',
      name: 'onboard.new_intern_offer',
      component: newInternOffer
    },
    {
      path: '/new_blue_research_offer',
      name: 'onboard.new_blue_research_offer',
      component: newBlueResearchOffer
    },
    {
      path: '/new_white_school_offer_stock',
      name: 'onboard.new_white_school_offer_stock',
      component: newWhiteSchoolOfferStock
    },
    {
      path: '/new_white_school_offer',
      name: 'onboard.new_white_school_offer',
      component: newWhiteSchoolOffer
    },
    {
      path: '/new_white_school_offer_en',
      name: 'onboard.new_white_school_offer_en',
      component: newWhiteSchoolOfferEn
    },
    {
      path: '/new_store_school_offer',
      name: 'onboard.new_store_school_offer',
      component: newStoreSchoolOffer
    },
    {
      path: '/new_white_school_charging_network_offer',
      name: 'onboard.new_white_school_charging_network_offer',
      component: newWhiteSchoolChargingNetworkOffer
    },
    {
      path: '/new_white_school_int_en_offer',
      name: 'onboard.new_white_school_int_en_offer',
      component: newWhiteSchoolIntEnOffer
    },
    {
      path: '/new_blue_intern_offer',
      name: 'onboard.new_blue_intern_offer',
      component: newBlueInternOffer
    },
    {
      path: '/new_common_offer',
      name: 'onboard.new_common_offer',
      component: newCommonOffer
    },
    {
      path: '/privacy_info',
      name: 'onboard.privacy_info',
      component: PrivacyInfo
    },
    {
      path: '/privacy_tips',
      name: 'onboard.privacy_tips',
      component: PrivacyTips
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js